import { cn } from "@babybjorn/ui";
import type {
	FC,
	FormEventHandler,
	FormHTMLAttributes,
	PropsWithChildren,
} from "react";
import FormInformation from "../../../components/Checkout/components/FormInformation/FormInformation";
import Button, { type ButtonVariant } from "../Button/Button";
import * as s from "./Form.module.scss";

type FormProps = PropsWithChildren<
	FormHTMLAttributes<HTMLFormElement> & {
		loading?: boolean;
		buttonLabel?: string;
		formInformation?: { icon: string; label: string; information: string };
		buttonIcon?: boolean;
		buttonVariant?: ButtonVariant;
		checkoutForm?: boolean;
		hideSubmitButton?: boolean;
	}
>;

const Form: FC<FormProps> = ({
	loading,
	children,
	buttonLabel,
	buttonVariant = "primary",
	buttonIcon = true,
	formInformation,
	hideSubmitButton,
	onSubmit,
	...rest
}) => {
	const onFormSubmit: FormEventHandler<HTMLFormElement> = (event) => {
		event.preventDefault();
		if (onSubmit) onSubmit(event);
	};

	return buttonLabel ? (
		<form {...rest} onSubmit={onFormSubmit} className={cn(s.form)}>
			<div className={cn(s.inputsContainer)}>{children}</div>

			{formInformation && (
				<FormInformation
					icon={formInformation.icon}
					label={formInformation.label}
					information={formInformation.information}
				/>
			)}

			{!hideSubmitButton && buttonIcon ? (
				<Button
					icon="cart"
					loading={loading}
					type="submit"
					variant={buttonVariant}
					label={buttonLabel}
					buttonType="standard"
					fullWidth
				/>
			) : (
				<Button
					loading={loading}
					type="submit"
					variant={buttonVariant}
					label={buttonLabel}
					buttonType="standard"
					fullWidth
				/>
			)}
		</form>
	) : (
		<form {...rest} className={cn(s.form)} onSubmit={onFormSubmit}>
			<div className={cn(s.inputsContainer)}>{children}</div>
		</form>
	);
};

export default Form;
